/**
 * Lógica compartida para manejar el click en una opción de respuesta.
 *
 * Reglas (per spec /v1/announcement/{id}/respond):
 *   - action_type === 'close' → cierra SIN registrar respuesta
 *   - action_type === 'url'   → registra respuesta + abre URL en nueva pestaña
 *   - action_type === 'none'  → registra respuesta y cierra
 *
 * Sin esta función la lógica vive duplicada entre Modal/Banner/Card y es
 * fácil olvidar el caso `close` (que registraba una respuesta antes —
 * bug que esta extracción corrige).
 */

import { AnnouncementOption } from '@interfaces/general';

interface HandleOptionActionArgs {
  option: AnnouncementOption;
  announcementId: string;
  respond: (announcementId: string, optionId: string, value: string) => Promise<unknown>;
  onComplete: () => void;
}

export async function handleOptionAction({
  option,
  announcementId,
  respond,
  onComplete,
}: HandleOptionActionArgs): Promise<void> {
  if (option.action_type === 'close') {
    onComplete();
    return;
  }

  const result = await respond(announcementId, option.id, option.value);

  // useRespondAnnouncement devuelve null cuando el POST falla (ya emite el
  // toast de error). En ese caso NO cerramos el UI para que el usuario pueda
  // reintentar.
  if (result === null) {
    return;
  }

  if (option.action_type === 'url' && option.action_url) {
    window.open(option.action_url, '_blank', 'noopener,noreferrer');
  }

  onComplete();
}
